module.exports = __webpack_public_path__ + "img/icon_e54.10de90cf.png";